import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

import { Section } from '../PageLayout'

export const VoiceControlStyled = styled(Section)`
  .content {
    display: flex;
    position: relative;
    background-color: ${({ theme }) => theme.backgroundDark};
    border-radius: 1.25rem;
    max-width: 960px;
    overflow: hidden;
    z-index: 0;

    @media (max-width: ${breakpoints.screenMD}) {
      max-width: 80%;
    }

    @media (max-width: ${breakpoints.screenSM}) {
      max-width: 100%;
    }
  }

  .title {
    margin-bottom: 3rem;

    @media (max-width: ${breakpoints.screenSM}) {
      margin-bottom: 1.5rem;
    }
  }

  .text {
    position: absolute;
    top: 14%;
    left: 50%;
    font-size: 1.75rem;
    transform: translateX(-50%);
    z-index: 3;
    width: 100%;

    @media (max-width: ${breakpoints.screenMD}) {
      font-size: 1.625rem;
      top: 16%;
    }
  }

  .img-container {
    position: relative;
    min-width: 100%;
  }

  .img-dark {
    width: 100%;
    max-height: none;
    opacity: 0;
    will-change: opacity;
    transition: opacity 0.3s ease-in-out;

    @media (max-width: ${breakpoints.screenSM}) {
      overflow: hidden;
      width: 200%;
      max-width: 200%;
    }

    &.visible {
      opacity: 1;
      z-index: 2;
    }
  }

  .img-all-on {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-height: none;
    opacity: 0;
    will-change: opacity;
    transition: opacity 0.3s ease-in-out;

    @media (max-width: ${breakpoints.screenSM}) {
      overflow: hidden;
      width: 200%;
      max-width: 200%;
    }

    &.visible {
      opacity: 1;
      z-index: 2;
    }
  }

  .img-tv-only {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-height: none;
    opacity: 0;
    will-change: opacity;
    transition: opacity 0.3s ease-in-out;

    @media (max-width: ${breakpoints.screenSM}) {
      overflow: hidden;
      width: 200%;
      max-width: 200%;
    }

    &.visible {
      opacity: 1;
      z-index: 2;
    }
  }

  .overlay {
    position: relative;
    width: 100%;
    height: 200px;
    margin-top: -200px;
    background-image: linear-gradient(356deg, #0d1116 30%, transparent);
    z-index: 3;
  }
`
